export const analyticsPageNames = {
  ACCOUNT: 'account',

  ADD_VOUCHER: 'account:add voucher',
  ADD_VOUCHER_SUCCESS: 'account:add voucher:success',
  ADD_VOUCHER_ERROR: 'account:add voucher:failed',

  // Sign in
  SIGN_IN: 'account:sign in',
  REGISTER: 'account:sign in:register',
  REGISTER_COMPLETE: 'account:sign in:register complete',
  REGISTER_COMPLETE_JOIN:
    'account:sign in:register complete:my john lewis:join now',
  REGISTER_COMPLETE_JOIN_COMPLETE:
    'account:sign in:register complete:my john lewis:join now complete',

  AUTH0_CALLBACK: 'account:auth0 callback',

  // Orders
  ORDERS: 'account:online orders',
  VIEW_ORDER: 'account:online orders:online order',

  // Track order
  TRACK_ORDER: 'account:track your order',
  TRACK_ORDER_FORM: 'account:track your order form',

  // VAT receipt
  VAT_RECEIPT: 'account:online orders:vat receipt',

  // Cancel order
  CANCEL_ORDER: 'account:online orders:cancel order:review',
  CANCEL_ORDER_CONFIRMED: 'account:online orders:cancel order:confirmation',

  // Cancel items
  CANCEL_ITEMS: 'account:online orders:cancel items:select items',
  CANCEL_ITEMS_REVIEW: 'account:online orders:cancel items:review refund',
  CANCEL_ITEMS_CONFIRMED: 'account:online orders:cancel items:confirmation',

  // Return items
  RETURN_ITEMS_METHOD: 'account:online orders:return items:return method',
  RETURN_ITEMS_INFORMATION:
    'account:online orders:return items:returns information',
  RETURN_ITEMS_SELECT: 'account:online orders:return items:choose items',
  RETURN_ITEMS_SUMMARY: 'account:online orders:return items:summary',
  RETURN_ITEMS_CONFIRMED: 'account:online orders:return items:return requested',
  RETURN_ITEMS_CONTACT: 'account:online orders:return items:contact us',

  // In Store Receipts
  IN_STORE_RECEIPTS: 'account:in-store receipts',
  IN_STORE_VIEW_RECEIPT: 'account:in-store receipts:view receipt',

  // Account details
  ACCOUNT_DETAILS: 'account:account details',
  ADDRESS_BOOK: 'account:account details:address book',
  ADDRESS_BOOK_ADD: 'account:account details:address book:add address',
  CONTACT_DETAILS: 'account:account details:contact details',
  CONTACT_DETAILS_ERROR:
    'account:account details:contact details:submit failed',
  CONTACT_DETAILS_EMAIL_ERROR:
    'account:account details:contact details:submit failed:email already linked',
  EDIT_PASSWORD: 'account:account details:edit password',
  ADD_PARTNER_CARD: 'account:account details:add partner card',
  ADD_PARTNER_CARD_SUCCESS: 'account:account details:add partner card:success',
  REMOVE_PARTNER_CARD: 'account:account details:remove partner card',
  REMOVE_PARTNER_CARD_SUCCESS:
    'account:account details:remove partner card:success',

  // Payment details
  PAYMENT_DETAILS: 'account:account details:payment details',
  PAYMENT_DETAILS_REMOVE_CARD:
    'account:account details:payment details:remove payment card',
  PAYMENT_DETAILS_REMOVE_CARD_FAILED:
    'account:account details:payment details:remove payment card:failed',
  PAYMENT_DETAILS_EDIT_CARD:
    'account:account details:payment details:edit payment card',
  PAYMENT_DETAILS_EDIT_CARD_FAILED:
    'account:account details:payment details:edit payment card:failed',

  // My JL
  MY_JL_JOIN: 'account:my john lewis:join now',
  MY_JL_JOIN_COMPLETE: 'account:my john lewis:join now complete',
  MY_JL_DETAILS: 'account:my john lewis:membership details',
  MY_JL_REQUEST_CARD: 'account:my john lewis:membership details:request card',
  MY_JL_REQUEST_CARD_CONFIRMED:
    'account:my john lewis:membership details:request card:confirmation',
  MY_JL_REQUEST_CARD_FAILED:
    'account:my john lewis:membership details:request card:failed',
  MY_JL_MEMBERSHIP_CANCEL:
    'account:my john lewis:membership details:cancel membership',
  MY_JL_MEMBERSHIP_CANCEL_CONFIRMED:
    'account:my john lewis:membership details:cancel membership:confirmation',
  MY_JL_MEMBERSHIP_CANCEL_FAILED:
    'account:my john lewis:membership details:cancel membership:failed',

  // Wish list
  WISH_LIST: 'account:wish list',
  WISH_LIST_LIST: 'account:wish list:list',

  // Marketing Preferences
  MARKETING_PREFERENCES: 'account:marketing preferences',
  MARKETING_PREFERENCES_UPDATE: 'account:marketing preferences:update',
  CONTACT_AND_HELP: 'account:contact and help',

  // Marketing consent form
  MARKETING_CONSENT: 'account:marketing consent form',
  MARKETING_CONSENT_COMPLETE: 'account:marketing consent form:complete',

  // Rewards and treats
  REWARDS_AND_TREATS: 'account:rewards and treats',
  REWARDS_AND_TREATS_FAILED: 'account:rewards and treats:failed',

  // Rewards and treats
  REWARD_AND_TREAT: 'account:rewards and treats:reward',
  REWARD_AND_TREAT_FAILED: 'account:rewards and treats:reward:failed',

  // Errors
  ERROR_PAGE: statusCode => `page not found:${statusCode} error page`,
};

// Event types
export const DATA_STATE_CHANGE = 'dataStateChange';
export const ERROR_PAGE = 'errorpage';
export const ERROR_404 = 'error404';
